import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "export-tem-download"
}
const _hoisted_2 = { class: "export-tem-download__failed" }

import { computed, onUnmounted, type PropType, watch } from 'vue';

import usePromise from '@exchange/libs/composables/shared/src/lib/usePromise';
import { ExportItem, ExportState } from '@exchange/libs/exports/service/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportItemDownload',
  props: {
  downloadItem: { type: Function as PropType<(id: string, isTradeItem: boolean) => Promise<void>>, required: true },
  fetchItem: { type: Function as PropType<(id: string, isTradeItem: boolean) => Promise<void>>, required: true },
  item: { type: Object as PropType<ExportItem>, required: true },
},
  setup(__props) {

const props = __props;

let refetchInterval: number | undefined;
const isTradeItem = computed(() => props.item.type === 'TRADES');
const download = usePromise(async () => {
  await props.downloadItem(props.item.id, isTradeItem.value);
});
const loading = computed(() => download.loading.value);
const isDownloadDisabled = computed(() => props.item.state !== ExportState.completed || loading.value);
const isFailed = computed(() => props.item.state === ExportState.failed);

watch(
  () => props.item.state === ExportState.inProgress,
  (value) => {
    clearInterval(refetchInterval);

    if (value) {
      refetchInterval = window.setInterval(() => {
        props.fetchItem(props.item.id, isTradeItem.value);
      }, 10_000);
    }
  },
  { immediate: true },
);

onUnmounted(() => clearInterval(refetchInterval));

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (!isFailed.value)
    ? (_openBlock(), _createBlock(_component_x_button, {
        key: 0,
        class: "export-tem-download",
        size: "xs",
        text: _ctx.$t('fundamentals.download'),
        disabled: isDownloadDisabled.value,
        loading: isDownloadDisabled.value || loading.value,
        variant: "dark-outline",
        onClick: _withModifiers(_unref(download).createPromise, ["stop"])
      }, null, 8, ["text", "disabled", "loading", "onClick"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('fundamentals.error.title')), 1)
      ]))
}
}

})